(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/validate/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/validate/page.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  memo = _React.memo;
const Image = svs.content.image_v2.Image;
const Button = svs.ui.ReactButton;
const SpeechBubble = svs.ui.ReactSpeechBubble.SpeechBubble;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const _svs$ticketsValidate$ = svs.ticketsValidate.components,
  OtpInput = _svs$ticketsValidate$.OtpInput,
  PageWrapper = _svs$ticketsValidate$.PageWrapper,
  SpeechBubbleTurSlim = _svs$ticketsValidate$.SpeechBubbleTurSlim,
  ScratchAnimation = _svs$ticketsValidate$.ScratchAnimation,
  actions = _svs$ticketsValidate$.actions;
const VALIDATED = svs.ticketsValidate.routes.VALIDATED;
const getShortNameByTicketId = svs.ticketsValidate.utils.getShortNameByTicketId;
const ImageMemo = memo(_ref => {
  let _ref$cssSelectors = _ref.cssSelectors,
    cssSelectors = _ref$cssSelectors === void 0 ? '' : _ref$cssSelectors,
    image = _ref.image;
  return React.createElement(Image, {
    cssSelectors: cssSelectors,
    image: image
  });
});
setGlobal('svs.ticketsValidate.pages.Validate', _ref2 => {
  let history = _ref2.history,
    match = _ref2.match;
  const _svs$ticketsValidate$2 = svs.ticketsValidate.components.context.useValidateContext(),
    dispatch = _svs$ticketsValidate$2.dispatch;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    code = _useState4[0],
    setCode = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    completedCode = _useState6[0],
    setCompletedCode = _useState6[1];
  const ticketInfo = svs.ticketsValidate.data.retailTicketInfo;
  const image = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.scratchImage) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.image);
  const type = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type;
  const onSubmit = async () => {
    const ticketId = match.params.ticketId;
    setLoading(true);
    svs.ui.loader.show();
    const _svs$ticketgames$tick = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(ticketId),
      shortName = _svs$ticketgames$tick.shortName;
    if (svs.core.userSession.isBlocked()) {
      svs.ticketsValidate.logger.info('User is blocked in NAR. Denying payment.');
      svs.accountservices.national_suspension_message.showNationalSuspensionPayMessage();
      svs.ui.loader.hide();
      setLoading(false);
      return;
    }
    try {
      const result = await svs.ticketsValidate.utils.validateTicket({
        ticketId,
        code
      });
      dispatch({
        type: actions.SET_RESULT,
        payload: result
      });
      const shortName = getShortNameByTicketId(ticketId);
      svs.ticketgames.ticketUtility.utils.tracking.trackValidateOneTimePassword(shortName);
      const win = result.winAmount > 0;
      svs.ticketgames.ticketUtility.utils.tracking.trackValidatedTicketResult(shortName, win);
      svs.ticketsValidate.logger.info("ticket successfully validated. type: ".concat(shortName, ", win: ").concat(win));
      history.push(VALIDATED.replace(':ticketId', ticketId).replace(':code', code));
    } catch (error) {
      await svs.ticketsValidate.utils.showErrorDialog(error, function () {
        let _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          resultCode = _ref3.resultCode,
          errorCode = _ref3.errorCode;
        svs.ticketsValidate.utils.redirectByError({
          resultCode,
          errorCode
        }, svs.ticketsValidate.utils.getBrandByTicketId(ticketId), ticketId);
      });
      if (svs.ticketsValidate.utils.resultCodes[error === null || error === void 0 ? void 0 : error.resultCode]) {
        svs.ticketsValidate.logger.info("ticket validation failed. type: ".concat(shortName, ", reason: ").concat(error === null || error === void 0 ? void 0 : error.resultCode));
      } else {
        svs.ticketsValidate.logger.error("ticket validation failed. type: ".concat(shortName, ", reason: ").concat(JSON.stringify(error)));
      }
    }
    svs.ui.loader.hide();
    setLoading(false);
  };
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center margin-bottom-2"
  }, React.createElement(GridCol, null, React.createElement("div", {
    style: {
      width: '300px',
      margin: '0px auto'
    }
  }, React.createElement("div", {
    className: "speech-bubble-wrapper"
  }, React.createElement(SpeechBubble, null, React.createElement(SpeechBubbleTurSlim, null, "Du f\xE5r det, vi lovar!"))), React.createElement("h1", {
    className: "h1"
  }, "Skrapa fram kod"), React.createElement("p", {
    className: "p"
  }, "Skriv in den ", React.createElement("b", null, "fyrsiffriga koden"), " som finns i kontrollrutan p\xE5 framsidan av lotten."), React.createElement("div", {
    className: "scratch-ticket"
  }, React.createElement("div", {
    className: "scratch-ticket-image-wrapper"
  }, image ? React.createElement(ImageMemo, {
    cssSelectors: "scratch-ticket-image ".concat(type),
    image: image
  }) : React.createElement("div", {
    className: "scratch-ticket-image"
  })), React.createElement(ScratchAnimation, {
    type: type
  })), React.createElement(OtpInput, {
    onChange: setCode,
    onComplete: setCompletedCode,
    onSubmit: onSubmit,
    value: code
  })))), React.createElement(GridRow, {
    className: "u-flex-justify-content-center margin-bottom-3"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 6,
    sm: 12
  }, React.createElement(Button, {
    block: true,
    disabled: !completedCode || code !== completedCode || loading,
    focus: true,
    onClick: onSubmit,
    type: "button"
  }, "Kontrollera vinst"))));
});

 })(window);